export const myProfileServiceMessages = {
  DEFAULT_ERROR: 'Something went wrong',
  GET_PROFILE_ERROR: 'Unable to load subscription information. Please try again.',
  EDIT_PROFILE_ERROR: 'Unable to update personal information. Please try again.',
  SET_PASSWORD_ERROR: 'Unable to update password. Please try again.',
};
